import { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, LabelXS } from '@sorare/core/src/atoms/typography';
import { Ellipsis } from '@sorare/core/src/atoms/typography/Ellipsis';

const Wrapper = styled.div`
  font: var(--t-body-s);
  color: var(--c-nd-600);
`;
const Count = styled.span`
  min-width: 3em;
  font: var(--t-body-s);
  text-align: right;
`;
const CardCount = styled(Count)`
  color: var(--c-white);
  min-width: unset;
`;
const Multiplier = styled(CardCount)`
  color: var(--c-nd-600);
  font-size: 0.8em;
  padding-right: 2px;
`;

type Prize = {
  icon: ReactNode;
  count: number;
  displayName: string;
  displayName2?: string;
  displayName3?: string;
};
type PrizePoolCategory = { category: string; prizes: Prize[] };
type Props = { prizePool: PrizePoolCategory[] };

const Rarities = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));

  --grid-gap: var(--unit);
  gap: var(--grid-gap);

  padding: var(--unit) 0;

  & > * {
    border-radius: var(--double-unit);
    border: 1px solid var(--c-nd-400);
    background-color: var(--c-black);
    padding: var(--intermediate-unit) var(--half-unit);
    text-align: center;
  }
`;
export const CollectionEventPrizePool = ({
  prizePool: prizePoolCategories,
}: Props) => {
  return (
    <Wrapper>
      <Vertical gap={3}>
        {prizePoolCategories.map(({ category, prizes }) => {
          return (
            <Vertical key={category} gap={1}>
              <BodyS bold as="div" color="var(--c-white)">
                {category}
              </BodyS>
              <Rarities>
                {prizes.map(prize => {
                  return (
                    <Vertical
                      center
                      key={`${prize.displayName}_${prize.displayName2 ?? ''}`}
                      gap={1}
                    >
                      {prize.icon}
                      <LabelXS color="var(--c-nd-700)">
                        <Vertical gap={0.5}>
                          <Ellipsis>{prize.displayName}</Ellipsis>
                          {prize.displayName2 && (
                            <div>{prize.displayName2}</div>
                          )}
                          {prize.displayName3 && (
                            <div>{prize.displayName3}</div>
                          )}
                        </Vertical>
                      </LabelXS>
                      <CardCount>
                        <Multiplier>x</Multiplier>
                        {prize.count}
                      </CardCount>
                    </Vertical>
                  );
                })}
              </Rarities>
            </Vertical>
          );
        })}
      </Vertical>
    </Wrapper>
  );
};
